import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowConfigVAlignValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'string',
            empty: false,
            mandatory: false
        };
    }
}
